<template>
    <span  style="font-weight: bold">
        number of contracts of separation:
        <b-form-select style="border:1px solid gray; width: auto"
                       v-model="numberOfContractsApart" :options="options"></b-form-select> 
    </span>
</template>

<script>
    import {commodityMonths} from "../js/main";

    export default {
        props: ['namespace'],
        computed: {
            options() {
                let commodity = this.$store.getters[this.namespace + '/c'][0];
                let numberOfMonths = commodityMonths(commodity).length;
                let temp = Array(numberOfMonths + 1).fill()
                        .map((x, i) => {
                            return {value: i, text: i};
                        });
                return temp;
            },
            numberOfContractsApart: {
                get() {
                    return this.$store.state[this.namespace].numberOfContractsApart;
                },
                set(numberOfContractsApart) {
                    this.$store.commit(this.namespace + '/setNumberOfContractsApart', numberOfContractsApart);
                }
            }
        }
    }
</script>
